import React from "react";
import { withTranslation } from "react-i18next";

const EventCard = ({ 
  eventImage, 
  hostImage, 
  hostName, 
  title, 
  price,
  firstAvailableScheduledDate,
  isRecurringEvent,
  eventDate, 
  dateFormat,
  t
}) => {
  return (
    <div className="event-card">
      <div className="img-container">
        <img src={eventImage} alt={t("way_activity.event_card.event_image_alt")} />
        <div className="host-container">
          <img src={hostImage} alt={t("way_activity.event_card.host_image_alt")} />
          <p>{hostName}</p>
        </div>
      </div>

      <div className="date-container">
        <p>{eventDate}</p>
      </div>

      <div className="bottom-title-container">
        <p className="date">{eventDate}</p>
        <p className="title">{title}</p>
        <p className="price">{t("way_activity.event_card.starting_from_label", { price })}</p> 
        {/* {!isRecurringEvent && <p> {`{This event is only available on ${moment(firstAvailableScheduledDate).format(dateFormat.toUpperCase())}}`}</p>} */}
      </div>
    </div>
  );
};

export default withTranslation("translations")(EventCard);
